import Icon from '3-components/Icon/Icon';
import React from 'react';
import { dataLayerResultClicked } from '../../../js/utils/dataLayers';

const HeaderSearchHit = ({ hit }) => {
    let iconName;
    if (hit.page_type === 'Blog post') {
        iconName = 'message-square';
    } else if (hit.page_type === 'Location') {
        iconName = 'map-pin';
    } else if (hit.page_type === 'Download') {
        iconName = 'import';
    } else {
        iconName = 'file';
    }

    return (
        <div className="header-search-result">
            <a
                href={hit.url}
                className="result-title"
                onClick={e => {
                    e.preventDefault();
                    const searchInput = document.querySelectorAll('.header-search-input .ais-SearchBox-input');
                    let searchterm = '';

                    for (let i = 0; i < searchInput.length; i += 1) {
                        if (searchInput[i].value !== '') {
                            const searchHits = document.getElementsByClassName('header-hits');
                            searchterm = searchInput[i].value;
                            // eslint-disable-next-line no-underscore-dangle
                            dataLayerResultClicked(searchterm, parseInt(searchHits[i].textContent, 10), hit.title, hit.__position);
                        }
                    }
                    window.location.href = hit.url;
                }}
            >
                <Icon icon={iconName} /> {hit.title}
            </a>
        </div>
    );
};

export default HeaderSearchHit;
